import PropTypes from "prop-types";
import React from "react";
import SVG from "theme/components/icons/base/SVG";

const CrossIcon = ({ color, ...props }) => (
    <SVG fill="none" {...props}>
        <path d="M14 2L2 14" stroke={color} />
        <path d="M14 14L2 2" stroke={color} />
    </SVG>
);

CrossIcon.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    viewBox: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

CrossIcon.defaultProps = {
    color: "currentColor",
    height: "16px",
    viewBox: "0 0 16 16",
    width: "16px",
};

export default CrossIcon;
